import { render, staticRenderFns } from "./statusColor.vue?vue&type=template&id=14d7a3cb"
import script from "./statusColor.vue?vue&type=script&lang=js"
export * from "./statusColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports